export default "__VITE_ASSET__ClfeBlyw__"